export { MEM_SPACE_ACCOUNT_ID } from "@/store/contacts/constants";

export const CONTEXT_KIND_LABELS: Record<string, string> = {
  clean_up: "Clean Up",
  chat: "Chat",
  mem_agent: "Mem Agent",
  voice_mode: "Voice Mode",
  email: "Email",
  mcp: "MCP",
  zapier: "Zapier",
  web_clip: "Web Clip",
};
